import { useEffect } from 'react'

export const DemographicFields = ({ id, agencyID, regions, professions, data, updateData, readOnly }) => {

  const settings = tangibleFields.store.getValue('tgbl_agency_enrolment_settings')
  const professionOptions = Object.keys(professions).length
    ? settings.professions.filter(profession => professions[profession.id])
    : settings.professions
  const regionOptions = regions.length
    ? settings.regions.filter(region => regions.includes(region.id))
    : settings.regions

  const resetValues = () => {
    if ( Object.keys(professions).length ) {
      if ( Object.keys(professions).length > 1 ) {
        tangibleFields.store.setValue( `agency-${id}-professions`, professionOptions.reduce((acc, curr) => {
          if ( data.professions.includes(curr.id) ) return acc === '' ? `p-${curr.id}` : `${acc},p-${curr.id}`
          return acc
        }, '' ))

      } else {
        tangibleFields.store.setValue( `agency-${id}-professions`, professionOptions[0].name)
      }
    }

    if ( regions.length || agencyID === null ) {
      if ( regions.length > 1 ) {
        tangibleFields.store.setValue( `agency-${id}-regions`, regionOptions.reduce((acc, curr) => {
          if ( data.regions.includes(curr.id) ) return acc === '' ? `r-${curr.id}` : `${acc},r-${curr.id}`
          return acc
        }, '' ))
      } else if ( agencyID === null ) {
        tangibleFields.store.setValue( `agency-${id}-regions`, data.regions[0] ? `r-${data.regions[0]}` : '' )
      } else {
        tangibleFields.store.setValue( `agency-${id}-regions`, regionOptions[0].name)
      }
    }
  }

  useEffect(() => {
    if ( Object.keys(professions).length ) tangibleFields.fields.rerender(`agency-${id}-professions`)
    if ( regions.length || agencyID === null ) tangibleFields.fields.rerender(`agency-${id}-regions`)

    // Adding timeout because ( on INITIAL render ) value is not set
    setTimeout(() => {
      resetValues()
    }, 100 )
  }, [agencyID])

  useEffect(() => { resetValues() }, [data])

  return (
    <>
      {( Object.keys(professions).length || regions.length || agencyID === null ) && <div className="tgbl-user-accrediting-agencies__list__item__panel__inner__form__demographic-fields">
        {/* HIDE PROFESSIONS FIELD IF AGENCY ID NULL */}
        { Object.keys(professions).length > 0 && tangibleFields.render({
          type: Object.keys(professions).length > 1 ? 'checkboxMultiselect' : 'text',
          name: `agency-${id}-professions`,
          label: `Profession${Object.keys(professions).length > 1 ? 's' : ''}`,
          multiple: true,
          choices: professionOptions.reduce((obj, profession) => {
            return { ...obj, [`p-${profession.id}`]: professions[profession.id] ?? profession.name }
          }, {}),
          ariaLabels: professionOptions.reduce((obj, profession) => {
            return { ...obj, [`p-${profession.id}`]: professions[profession.id] ? profession.name : '' }
          }, {}),
          readOnly: Object.keys(professions).length > 1 ? readOnly : true,
          onChange: value => {
            let newProfessions = [ ...data.professions ]

            if ( Object.keys(professions).length > 1 ) {
              const selected = value.split(',')
              professionOptions.forEach( profession => {
                if ( selected.includes(`p-${profession.id}`) && !newProfessions.includes(profession.id) )
                  newProfessions = [ ...newProfessions, profession.id ]
                else if ( !selected.includes(`p-${profession.id}`) && newProfessions.includes(profession.id) )
                  newProfessions = newProfessions.filter( i => i !== profession.id )
              })

            } else {
              if ( !newProfessions.includes(professionOptions[0].id) ) {
                newProfessions = [ ...newProfessions, professionOptions[0].id ]
              }
            }

            updateData( 'professions', newProfessions )
          },
        })}
        { ( regions.length || agencyID === null ) && tangibleFields.render({
          // type: agencyID ? 'checkboxMultiselect' : 'combo-box',
          type: agencyID === null
            ? 'select'
            : ( regions.length > 1 ? 'checkboxMultiselect' : 'text' ),
          name: `agency-${id}-regions`,
          label: `State${regions.length > 1 ? 's' : ''}`,
          multiple: agencyID !== null,
          choices: regionOptions.reduce((obj, region) => {
            return { ...obj, [`r-${region.id}`]: agencyID !== null && region.code ? region.code : region.name }
          }, {}),
          ariaLabels: regionOptions.reduce((obj, region) => {
            return { ...obj, [`r-${region.id}`]: region.code ? region.name : '' }
          }, {}),
          readOnly: regions.length > 1 || agencyID === null ? readOnly : true,
          onChange: value => {
            let newRegions = [ ...data.regions ]

            if ( Object.keys(regions).length > 1 ) {
              const selected = value.split(',')
              regionOptions.forEach( region => {
                if ( selected.includes(`r-${region.id}`) && !newRegions.includes(region.id) )
                  newRegions = [ ...newRegions, region.id ]
                else if ( !selected.includes(`r-${region.id}`) && newRegions.includes(region.id) )
                  newRegions = newRegions.filter( i => i !== region.id )
              })

            } else if ( agencyID === null ) {
              if ( value === '' ) return
              newRegions = [ parseInt(value.substring(2)) ]

            } else {
              if ( !newRegions.includes(regionOptions[0].id) ) {
                newRegions = [ ...newRegions, regionOptions[0].id ]
              }
            }

            updateData( 'regions', newRegions )
          },
        })}
      </div>}
    </>
  )
}
